var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLanguageCheckOn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 0.5H12C13.0938 0.5 14 1.40625 14 2.5V12.5C14 13.625 13.0938 14.5 12 14.5H2C0.875 14.5 0 13.625 0 12.5V2.5C0 1.40625 0.875 0.5 2 0.5ZM10.5312 6.03125H10.5C10.8125 5.75 10.8125 5.28125 10.5 4.96875C10.2188 4.6875 9.75 4.6875 9.46875 4.96875L6 8.46875L4.53125 7C4.21875 6.6875 3.75 6.6875 3.46875 7C3.15625 7.28125 3.15625 7.75 3.46875 8.03125L5.46875 10.0312C5.75 10.3438 6.21875 10.3438 6.53125 10.0312L10.5312 6.03125Z",
    fill: "#1C32F3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanguageCheckOn);
export default __webpack_public_path__ + "static/media/language-check-on.824a436fbc67b4f52738518df7a6d99c.svg";
export { ForwardRef as ReactComponent };